module.exports = __webpack_public_path__ + "c2618cc6d6938a28de44476ab92ece64.svg";